import React, { useState ,useEffect} from 'react';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import map from 'lodash/map';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import size from 'lodash/size';

const propTypes = {
  collection: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldLabel: PropTypes.string.isRequired,
  fieldDell: PropTypes.bool.isRequired,
};

const defaultProps = {
  collection: [],
  selectedIds: [],
  setFieldValue: () => {
  },
  fieldName: '',
  fieldLabel: '',
  fieldDell: true,
};

function ChipCity({
  collection,
  selectedIds,
  setFieldValue,
  fieldLabel,
  fieldDell
}) {
  const selectedOptions = filter(collection, (option) => includes(selectedIds, option.id));
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(!Boolean(size(collection)));
  }, [collection,selectedIds]);

  if (loading) return (<p>...</p>);

  return (
    <Autocomplete
      multiple
      disableClearable
      disableCloseOnSelect
      options={collection}
      getOptionLabel={option => option.name}
      value={selectedOptions}
      filterSelectedOptions
      onChange={(event, values) => {
        setFieldValue(map(values, 'id'));
      }}
      renderTags={(value, getTagProps) =>
        map(value, (option, index) => (
          <Chip
            size="small"
            label={option.name}
            {...getTagProps({ index })}
            disabled={!fieldDell}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          variant="standard"
          label={fieldLabel}
        />)
      }
    />
  );
}

ChipCity.propTypes = propTypes;
ChipCity.defaultProps = defaultProps;

export default ChipCity;




// WEBPACK FOOTER //
// ./src/components/ChipCity/index.jsx